export const semesters = {
    spring: "Spring",
    summer: "Summer",
    fall: "Fall",
    winter: "Winter",
}
